<script setup lang="ts">
import PrimeButton from "primevue/button";

withDefaults(defineProps<{
  label?: string;
  iconOnly?: boolean;
  variant?: "primary" | "secondary" | "ghost" | "danger";
  size?: "sm" | "md";
  disabled?: boolean;
  type?: "button" | "submit";
}>(), { variant: "secondary", size: "md", type: "button" });

defineEmits<{ click: [event: MouseEvent] }>();
</script>

<template>
  <PrimeButton
    :label="label"
    :disabled="disabled"
    :type="type"
    unstyled
    :class="['v-button', `v-button--${variant}`, `v-button--${size}`, { 'v-button--icon': iconOnly }]"
    @click="$emit('click', $event)"
  >
    <slot />
  </PrimeButton>
</template>
